module.exports = __webpack_public_path__ + "d8bf0a5fdfb3b2d05f0d8578e6a53520.png";